// extracted by mini-css-extract-plugin
export default {"games_section_headline":"notification_games_section_headline__6Yy4P","games_section_title":"notification_games_section_title__xp1Jy"};